import api from './api';

const menuPreferencesService = {
  /**
   * Busca preferências de menu para um projeto
   * @param {string} projectId - ID do projeto
   * @returns {Promise} Preferências do menu
   */
  async getPreferences(projectId) {
    try {
      const response = await api.get(`/menu-preferences/${projectId}`);
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar preferências de menu:', error);
      throw error;
    }
  },

  /**
   * Salva preferências de menu para um projeto
   * @param {string} projectId - ID do projeto
   * @param {object} preferences - Objeto de preferências
   * @returns {Promise} Resultado da operação
   */
  async savePreferences(projectId, preferences) {
    try {
      const response = await api.post(`/menu-preferences/${projectId}`, {
        preferences
      });
      return response.data;
    } catch (error) {
      console.error('Erro ao salvar preferências de menu:', error);
      throw error;
    }
  },

  /**
   * Reseta preferências para o padrão
   * @param {string} projectId - ID do projeto
   * @returns {Promise} Preferências padrão
   */
  async resetPreferences(projectId) {
    try {
      const response = await api.delete(`/menu-preferences/${projectId}/reset`);
      return response.data;
    } catch (error) {
      console.error('Erro ao resetar preferências de menu:', error);
      throw error;
    }
  }
};

export default menuPreferencesService;
